import ch31Eligibility from './ch31-my-eligibility-and-benefits';

export default {
  ch31Eligibility,
};
